import React from "react";
import styled from "styled-components";
import { faLink } from "@fortawesome/free-solid-svg-icons";
import { faCode } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import COLORS from "../styled.constants";

const WorkList = ({ img, link, alt, title, text, desc, github }) => {
  const List = styled.div`
    width: 100%;
    height: 100%;
    box-shadow: 6px -1px 20px 0px rgba(0, 0, 0, 0.45);
    border-radius: 15px;
    overflow: hidden;

    .project {
      width: 100%;
      height: 100%;
    }

    .project--img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .project__description {
      position: absolute;
      background-color: black;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding-top: 2rem;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      opacity: 0;
      transform: translateY(10px);
      transition: all var(--animation-duration) ease-in;
    }

    .project:hover .project__description {
      opacity: 0.8;
      transform: translateY(0px);
    }

    .project__description {
      text-align: center;
      h3 {
        color: white;
        font-size: 1.5em;
        font-weight: 500;
      }
      h5 {
        padding-top: 0.6rem;
        margin: 0 auto;
        width: 100%;
        max-width: 500px;
        font-size: 1em;
        font-weight: lighter;
        color: ${COLORS.text};
      }
      .desc {
        padding-top: 0.8rem;
      }

      .clickBtn {
        margin-top: 2rem;
        display: flex;
        justify-content: center;
      }
      .viewBtn {
        font-size: 1.5em;
        color: white;
        border: 1px solid ${COLORS.button};
        border-radius: 50px;
        padding: 0.2rem;
        width: 50px;
        height: 35px;
        background-color: ${COLORS.button};
        cursor: pointer;
        margin-right: 2rem;
        margin-left: 2rem;
        margin-bottom: 2rem;
      }
    }

    .project__description h3:after {
      content: "";
      display: block;
      position: relative;
      left: 50%;
      width: 50px;
      height: 2px;
      transform: translateX(-50%);
      margin-top: 8px;
      background-color: white;
    }

    @media only screen and (max-width: 768px) {
      height: 50vh;
      .project--img {
        height: 50vh;
      }
    }
  `;

  const Browser = styled.div`
    height: 1.8rem;
    background-color: rgba(0, 0, 0, 0.08);
    display: flex;
    align-items: center;
  `;

  const Circle = styled.div`
    width: 0.6rem;
    height: 0.6rem;
    border-radius: 50%;
    background-color: white;
    margin: 0.15rem;
  `;

  //   const Image = styled.img`
  //     width: 100%;
  //     height: 100%;
  //     object-fit: cover;
  //   `;

  //   const Description = styled.div`
  //     h3 {
  //       font-size: 2em;
  //     }
  //     position: absolute;
  //     background-color: navy;
  //     width: 100%;
  //     height: 100%;
  //   `;

  return (
    <>
      <List>
        <Browser>
          <Circle />
          <Circle />
          <Circle />
        </Browser>
        {/* <a href={link} target="_blank" rel="noreferrer" className="project"> */}
        <div className="project">
          <img className="project--img" src={img} alt={alt} />
          <div className="project__description">
            <h3>{title}</h3>
            <h5>{text}</h5>
            {/* <div className="explanation">{explanation}</div> */}
            <div className="desc">{desc}</div>
            <div className="clickBtn">
              <button className="viewBtn">
                <a href={link} target="blank">
                  <FontAwesomeIcon icon={faLink} />
                </a>
              </button>
              <button className="viewBtn">
                <a href={github} target="blank">
                  <FontAwesomeIcon icon={faCode} />
                </a>
              </button>
            </div>
          </div>
        </div>
      </List>
    </>
  );
};

export default WorkList;
